export default __webpack_public_path__ + "static/media/Logo.377e0234.svg";